<app-header [checkinVisitorType$]="visitStateService.visitorType$"></app-header>
<app-stepper [steps$]="applicationStateService.steps$"></app-stepper>
<div class="content">
  <h1 class="title">
    <div>Unfortunately</div>
    <div>we could not confirm your identity</div>
  </h1>

  <div class="image sad-user"></div>

  <h2 class="title">
    <div>You can try again with the same ID.</div>
    <div>Alternately, you may ask for assistance or proceed to the reception desk.</div>
  </h2>

  <div class="actions">
    <button center class="next" (click)="onRetryScan()" [disabled]="isRunningProcess">
      <i class="icon icon-arrow-left"></i>
      <span class="label">Retry scan</span>
    </button>

    <button center class="exit" (click)="exit()" [disabled]="isRunningProcess">
      <span class="label">Go to reception</span>
      <i class="icon icon-arrow-right"></i>
    </button>
  </div>

  <button center class="byPass" (click)="byPass()" [disabled]="isRunningProcess">
    <span class="label">For official use only</span>
  </button>
</div>
